import { TransformsList } from 'cio/utils/analytics/transforms';

const Transforms: TransformsList = {
  versionChangeStarted(data: Record<string, any>) {
    let eventData: Record<string, any> = {
      'Current Version': getTermplateEngineName(data.currentVersion),
      'Workspace Setting': data.isWorkspaceSetting,
    };

    if (data.isWorkspaceSetting !== true) {
      eventData['Template ID'] = data.templateId;
    }

    return eventData;
  },

  versionChangeCompleted(data: Record<string, any>) {
    let eventData: Record<string, any> = {
      Version: getTermplateEngineName(data.version),
      'Workspace Setting': data.isWorkspaceSetting,
    };

    if (data.isWorkspaceSetting !== true) {
      eventData['Template ID'] = data.templateId;
    }

    return eventData;
  },
};

function getTermplateEngineName(engineValue: number | string | null) {
  if (engineValue === 0 || engineValue === '0') {
    return 'ruby';
  }
  if (engineValue === 1 || engineValue === '1') {
    return 'liquidjs';
  }
  return '';
}

export default Transforms;
